import React from 'react'
import ScreeningTemplate from './ScreeningTemplate.jsx'

export default React.createClass({
    render(){
        return (
            <div>
                <ScreeningTemplate requestId={this.props.location.query.request} />
            </div>
        )
    }
});



// WEBPACK FOOTER //
// app/views/Lead/Screening/index.js